export default __webpack_public_path__ + "static/cta-subscribe-bg-b9467a45d7df97c9d883939d7f78ee96.png";